<template>
  
  <v-container>
  <!-- <v-container grid-list-md text-xs-center> -->
    <!-- <v-layout> -->
    <v-layout row wrap>
      <!-- <v-flex xs12 sm6 offset-sm3> -->
      <!-- MEMO このv-if="appSettingsのおかげで、その下のコンポーネントはcreated時にappSettingsを取得可能。" -->
      <v-flex xs12 v-if="appSettings">
        <!-- <ResultOfJavaScript /> -->
        <ResultOfNetwork 
          :connectData="appSettings.connectData"
          :connectionLimit="appSettings.connectionLimit"
           />
        <ResultOfUserEnv :usrEnvSettings="appSettings.userEnv" />
        <ResultOfTimeZone :timeZoneSettings="appSettings.timezone"/>
        <p class="text-xs-right grey--text">{{appVersion}}</p>
        
      </v-flex>
    </v-layout>
    
  </v-container>
</template>

<script>
import axios from 'axios'
// import ResultOfJavaScript from '@/components/Results/ResultOfJavaScript.vue'
import ResultOfTimeZone from '@/components/Results/ResultOfTimeZone.vue'
import ResultOfNetwork from '@/components/Results/ResultOfNetwork.vue'
import ResultOfUserEnv from '@/components/Results/ResultOfUserEnv.vue'
import { VERSION } from '@/constants.js'
export default {
  name: 'ResultView',
  components: {
    // ResultOfJavaScript,
    ResultOfTimeZone,
    ResultOfNetwork,
    ResultOfUserEnv
  },
  data () {
    return {
      appVersion: VERSION,
      appSettings: null
    }
  },
  async created () {
    const { data } = await axios.get('settings.json')
    this.appSettings = data
  }
}
</script>

<style>

</style>
